export class DatiDepositoDTO {
    causale: string;
	importo: number;
	nota: string;
}